import React from "react";
import * as styles from "./DestacadosMobile.module.scss";
import { Link } from "gatsby-plugin-react-i18next";
import FeaturedCard from "../AccordionContent/FeaturedCard/FeaturedCard";
import ventilador from "../../../images/venti_abierto.png";
import ventiladorCerrado from "../../../images/venti_cerrado.png";
import vitroBlanco from "../../../images/vitro__blanco.png";
import vitroNegro from "../../../images/vitro__negro.png";
import cafereta from "../../../images/cafetera2.png";
import FeaturedTermo from "../AccordionContent/FeaturedTermo/FeaturedTermo";
import termo1 from "../../../images/1.png";
import termo2 from "../../../images/2.png";
import termo3 from "../../../images/3.png";
import FeaturedVentilador from "../AccordionContent/FeaturedVentilador/FeaturedVentilador";
import freidora from "../../../images/nav-productosDest/freidora-inox.png";
import FeaturedCafetera from "../DestacadosMobile/FeaturedCafetera";



const DestacadosMobile = () => {

    return (
        <div className={styles.container_destacados}>
            <div>
            <p className={styles.title}>Productos destacados</p>
            </div>
            <div className={styles.container__img}>
                <div className={styles.imageSection}>
                    <Link to="/etermo">
                    <FeaturedTermo
                        FirtsImg={termo1}
                        SecondImg={termo2}
                        ThirdImg={termo3}
                        title={"Etermo"}
                    />
                    </Link>
                    <Link to="/ventilador">
                    <FeaturedVentilador
                        FirtsImg={ventilador}
                        SecondImg={ventiladorCerrado}
                        title={"Ventilador Retráctil"}
                    />
                    </Link>
                </div>
                <div className={styles.imageSection}>
                    <Link to="/cafetera">
                    <FeaturedCafetera
                        FirtsImg={cafereta}
                        SecondImg={cafereta}
                        title={"Cafetera"}
                    />
                    </Link>
                    <Link to="/detalle/freidora-de-aire-parrilla-pe-afg03n-ar/">
                    <FeaturedCard
                      FirtsImg={freidora}
                      SecondImg={freidora}
                      title={"Freidora de aire"}
                    />
                    </Link>
                </div>
            </div>
        </div>)
};       

export default DestacadosMobile;